__turbopack_context__.v({
  "bannerItem": "DesktopCarouselBanner-module__JybAXG__bannerItem",
  "bannerWrapper": "DesktopCarouselBanner-module__JybAXG__bannerWrapper",
  "divider": "DesktopCarouselBanner-module__JybAXG__divider",
});
